// extracted by mini-css-extract-plugin
module.exports = {"carouselArrow":"Arrow_carouselArrow__3tyZm","arrow":"Arrow_arrow__2XkeC"};